'use strict';
const RemoteModelInterface = require('./RemoteModelInterface');
const linkUtils = require('./linkUtils');
const uriUtils = require('./uriUtils');
const richTextUtils = require('./richTextUtils');
const videoUrlsUtils = require('./videoUrlsUtils/videoUrlsUtils');
const repeaterUtils = require('./repeaterUtils/repeaterUtils');
const TypeUtils = require('./typeUtils/typeUtils');
const backgroundUtils = require('./backgroundUtils');
const svgUtils = require('./svgUtils');
const typeData = require('./typeUtils/typeData');
const componentsHooks = require('./RMIHooks/componentsHooks');

module.exports = {
  RemoteModelInterface,
  linkUtils,
  uriUtils,
  richTextUtils,
  videoUrlsUtils,
  repeaterUtils,
  backgroundUtils,
  svgUtils,
  componentsHooks,
  typeUtils: new TypeUtils(typeData)
};



// WEBPACK FOOTER //
// ./src/main.js